export const HYGRAPH_PAGE_REGISTRATION_CONSENT_ID = 'clk229hb74i1l0bk9i7b7oyba' as const;
export const HYGRAPH_PAGE_ACCOUNT_ID = 'clnj2gexfupib0clbv7kbl98r' as const;
export const HYGRAPH_DASHBOARD_HEALTH_REPORT_ID = 'clzmr7wxn0f7708k8uszarcnf' as const;
export const HYGRAPH_FOOTER_ID = 'cljnwapw21ywi0bk7vhpdp07g' as const;
export const HYGRAPH_PAGE_LI_DASHBOARD_ID = 'clniv1gatwzky0alj3co4s6kp' as const;
export const HYGRAPH_PAGE_REGISTRATION_MARKETING_CONSENTS_ID = 'cm85ws0ac0ggx0dlmo630d5vr' as const;
export const HYGRAPH_SHOPPING_CART_ID = 'cmc8twvmv4bgz07k2cof7cf3m' as const;

export const HYGRAPH_TOP_NAV_ID = Object.freeze({
  US: 'cm1esj61m5gwd07le2wm1llp6',
  ALL: 'cljnupwsz1yde0algbumo9dds',
  CA: 'cme8k2a5of40p07lez1fba2ml',
});
